// DO NOT EDIT THIS FILE!
// This file is autogenerated by the Parcel web application bundler.

import './app';
import '../../blocks/contact-list/scripts/view';
import '../../blocks/cross-reference/scripts/view';
import '../../blocks/embed/scripts/view';
import '../../blocks/expandable-list/scripts/view';
import '../../blocks/expandable-list-item/scripts/view';
import '../../blocks/file-downloads/scripts/view';
import '../../blocks/flexible-image-grid/scripts/view';
import '../../blocks/grid/scripts/view';
import '../../blocks/hero/scripts/view';
import '../../blocks/image/scripts/view';
import '../../blocks/image-carousel/scripts/view';
import '../../blocks/read-more-button/scripts/view';
import '../../blocks/rich-text/scripts/view';
import '../../blocks/search-result/scripts/view';
import '../../blocks/tab-menu/scripts/view';
import '../../blocks/video/scripts/view';
import '../../blocks/share-on-social-media/scripts/view';
import '../../blocks/stories-grid/scripts/view';
import '../../blocks/latest-news/scripts/view';
import '../../blocks/sff-campaign/scripts/view';
